module.exports = __webpack_public_path__ + "static/img/ZiJinGuanLiJiaShiCang.531690be.jpg";